module.exports = __webpack_public_path__ + "img/Intramural_fields_-_PF-t-27635-033.950077a5.jpg";